
<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('employee_list') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <router-link to="/employee" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <div>
                                    <input type="text" class="form-control form-control-sm" :placeholder="$t('search')" v-model="query.Text" @keypress.enter="toList">
                                </div>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-striped table-sm no-bor">
                        <thead>
                            <tr>
                                <th>{{$t('no')}}</th>
                                <th>{{$t('employee_num')}}</th>
                                <th>{{$t('khmer_name')}}</th>
                                <th>{{$t('latin_name')}}</th>
                                <th>{{$t('card_no')}}</th>
                                <th>{{$t('sex')}}</th>
                                <th>{{$t('job')}}</th>
                                <th>{{$t('working_place')}}</th>
                                <th>{{$t('phone')}}</th>
                                <th>{{$t('dob')}}</th>
                                <th>{{$t('join_date')}}</th>
                                <th>{{$t('confirm_date')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in records" :key="index">
                                <td>{{index+1}}</td>
                                <td><router-link :to="{ name: 'employee_update', params: {id: ret.Id}}">{{ret.Num}}</router-link></td>
                                <td>{{ret.KhmerName}}</td>
                                <td>{{ret.LatinName}}</td>
                                <td>{{ret.CardNo}}</td>
                                <td>{{ret.Sex}}</td>
                                <td>{{ret.Job}}</td>
                                <td>{{ret.WorkPlaceName}}</td>
                                <td>{{ret.Phone}}</td>
                                <td>{{$format(ret.Dob, 'DD-MMM-YYYY')}}</td>
                                <td>{{$format(ret.JoinDate, 'DD-MMM-YYYY')}}</td>
                                <td>{{$format(ret.ConfirmDate, 'DD-MMM-YYYY')}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{query.Total}}</span>
                    <div class="pull-right">
                        <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                        hide-goto-end-buttons
                        @change="paging($event)"/>
                    </div>
                </div> 
            </div>    
        </div>
    </div>
</template>
<script>
export default {
    data: function(){
        return {
            query:{
                Text: '',
                Page: 1,
                Total: 0,
                Limit: 25
            },
            records:[]
        }
    },
    created: function(){
        this.toList();
    },
    methods: {
        toList(){
            var loading = this.$loading.show();
            this.$api().post('employees', this.query).then(res => {
                if(this.$isValid(res)){
                    this.records = res.data.Data;
                    this.query.Total = res.data.Total;
                }
            }).finally(function() { loading.hide(); });
        },
        paging(e){
            this.query.Page = e;
            this.toList();
        }
    }
}
</script>